
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manufacturer",
      function () {
        return require("private-next-pages/manufacturer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manufacturer"])
      });
    }
  